import { CallApiOptions } from './api';
import { merge } from 'ramda';

export const clusterListCallOptions = (
  params: object = {}
): CallApiOptions => ({
  method: 'GET',
  endpoint: 'clusters',
  params: {
    limit: 20,
    ...params,
  },
});

export const fetchClusterCallOptions = (
  clusterId: number,
  include: string[]
): CallApiOptions => ({
  method: 'GET',
  endpoint: `clusters/${clusterId}?include=stories.appConfigs,stories.clusterStory,images`,
  // TODO: This params syntax will NEVER work if you have more than 2 includes!?
  // it will always take the last include, because includes are interpreted as
  // key/value pairs and you'll get something like
  // ?include=stories&include=stories.appConfigs&include=...
  // params: {
  //   include: ['stories', 'stories.appConfigs', 'stories.clusterStory']
  // }
});

export const putClusterCallOptions = (
  clusterId: number,
  cluster: any,
  additionalData?: object
): CallApiOptions => {
  const data = merge(cluster, additionalData || {});

  return {
    method: 'PUT',
    endpoint: `clusters/${clusterId}?include=stories.appConfigs,stories.clusterStory`,
    body: JSON.stringify(data),
  };
};

export const postClusterCallOptions = (cluster: any): CallApiOptions => ({
  method: 'POST',
  endpoint: `clusters`,
  body: JSON.stringify(cluster),
  params: {
    include: ['stories', 'stories.appConfigs'],
  },
});

export const deleteClusterCallOptions = (
  clusterId: number
): CallApiOptions => ({
  method: 'DELETE',
  endpoint: `clusters/${clusterId}`,
  params: {
    include: ['stories', 'stories.appConfigs'],
  },
});



// WEBPACK FOOTER //
// ./src/services/clusterlist.services.ts